import { useState } from "react";
import { isPlatform } from "@ionic/react";
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { Filesystem } from "@capacitor/filesystem";
import _ from "lodash";

export interface UserPhoto {
  filepath: string;
  webviewPath?: string;
  base64: string;
}

export function usePhoto() {
  const [photos, setPhotos] = useState<UserPhoto>();

  const takePhoto = async (source: CameraSource = CameraSource.Prompt) => {
    let cameraPhoto: any;
    try {
      cameraPhoto = await Camera.getPhoto({
        resultType: CameraResultType.Uri,
        source: source,
        quality: 100,
      });
    } catch (e) {
      console.log("no photo");
    }

    console.log("cameraPhoto photo => ", cameraPhoto);
    if (!_.isEmpty(cameraPhoto)) {
      const fileName = new Date().getTime() + ".jpeg";
      let base64Data: string;
      let webviewPath: string;

      /* Hybrid  */
      if (isPlatform("hybrid")) {
        webviewPath = cameraPhoto.path!;

        const file = await Filesystem.readFile({
          path: cameraPhoto.path!,
        });

        base64Data = "data:image/png;base64," + file.data;
      } else {
        base64Data = await base64FromPath(cameraPhoto.webPath!);

        webviewPath = cameraPhoto.webPath!;
      }

      const newPhotos = {
        filepath: fileName,
        webviewPath: cameraPhoto.webPath,
        base64: base64Data,
      };
      setPhotos(newPhotos);
    }
  };

  return {
    photos,
    takePhoto,
  };
}

export async function base64FromPath(path: string): Promise<string> {
  try {
    const response = await fetch(path);
    const blob = await response.blob();
    const base64Data = await blobToBase64(blob);
    return base64Data;
  } catch (error) {
    console.error("Error fetching or converting to base64:", error);
    return "";
  }
}

async function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result);
      } else {
        reject("method did not return a string");
      }
    };

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;

      ctx?.drawImage(img, 0, 0);

      canvas.toBlob((blob) => {
        if (blob) {
          reader.readAsDataURL(blob);
        } else {
          reject("Error converting to base64: Blob is null");
        }
      }, "image/jpeg");
    };

    img.src = URL.createObjectURL(blob);
  });
}
